'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.Rsql', ['AVRO.Common.Moment']).factory('RsqlParserService', require('./services/RsqlParserService')).factory('RsqlQueryService', require('./services/RsqlQueryService')).factory('RsqlQueryFactory', require('./factories/RsqlQueryFactory'));